import { PhoneCall, ClipboardList, CheckCircle2 } from "lucide-react";

const STEPS = [
    {
        icon: PhoneCall,
        step: "01",
        title: "Get in touch",
        desc: "Give us a quick call or send an email with what you need doing. The more detail you can share, the better.",
    },
    {
        icon: ClipboardList,
        step: "02",
        title: "Receive a clear quote",
        desc: "We&apos;ll come back to you with an honest, no-obligation quote and a time we can fit you in.",
    },
    {
        icon: CheckCircle2,
        step: "03",
        title: "Job done properly",
        desc: "We turn up on time, do the work to a high standard, tidy up, and only leave when you&apos;re happy.",
    },
];

export default function HowItWorks() {
    return (
        <section
            id="how-it-works"
            data-testid="how-it-works-section"
            className="py-24 md:py-32 bg-white"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-3xl">
                    <div className="text-xs uppercase tracking-[0.2em] text-amber-700 font-bold mb-4">
                        How it works
                    </div>
                    <h2 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900">
                        Three simple steps from
                        <br />
                        phone call to{" "}
                        <span className="text-amber-600">job done.</span>
                    </h2>
                </div>

                <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6">
                    {STEPS.map(({ icon: Icon, step, title, desc }, idx) => (
                        <div
                            key={step}
                            data-testid={`how-step-${step}`}
                            className="relative bg-slate-50 border border-slate-200 rounded-xl p-8 hover:border-amber-300 hover:bg-white hover:shadow-md transition-all"
                        >
                            <div className="absolute -top-4 left-8 px-3 py-1 rounded-full bg-slate-900 text-white text-xs font-bold tracking-widest">
                                STEP {step}
                            </div>
                            <div className="w-14 h-14 rounded-xl bg-amber-100 border border-amber-200 flex items-center justify-center mb-6 mt-2">
                                <Icon className="w-7 h-7 text-amber-700" />
                            </div>
                            <h3 className="font-display text-2xl font-bold text-slate-900">
                                {title}
                            </h3>
                            <p
                                className="mt-3 text-slate-600 leading-relaxed"
                                dangerouslySetInnerHTML={{ __html: desc }}
                            />
                            {idx < STEPS.length - 1 && (
                                <div className="hidden md:block absolute top-1/2 -right-3 w-6 h-px bg-slate-300" />
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
